import { Stack } from "@mui/material";
import { StyledButton } from "./link-tree.styles";
import { links } from "./link-tree.const";
import { MailingListForm } from "../mailing-list-form/mailing-list-form";
import { evaluateCondition } from "./link-tree.utils";

export const LinkTree = () => {
  const visibleLinks = links.filter(link => evaluateCondition(link.condition));

  return (
    <Stack spacing={2}>
      {visibleLinks.map((link) => {
        return (
          <StyledButton
            key={link.label}
            component='a'
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
          >
            {link.label}
          </StyledButton>
        );
      })}
      <MailingListForm />
    </Stack>
  );
};
